import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page24',
  templateUrl: './page24.component.html',
  styleUrls: ['./page24.component.css']
})
export class Page24Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
